import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 策略列表
	 * @param {page} 第几页
	 * @param {pageSize} 每页数量
	**/
	strategyList( params={} ) {
		return request({
	    url: baseUrl + '/device/Strategy',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 策略编辑
	**/
	strategyEdit(id,data){
		return request({
			url: baseUrl + '/device/Strategy/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 策略添加
	**/
	strategyAdd(data){
		return request({
			url: baseUrl + '/device/Strategy',
			method:'POST',
			data
		})
	},

	/**
	 * 策略删除
	**/
	strategyDel(id){
		return request({
			url: baseUrl + '/device/Strategy/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 策略分配-分配或者取消策略
	 * @param {type} 0未分配1已分配
	 * @param {lamp_ids} 1,2,3 所选设备
	 * @param {stg_id} 策略ID
	**/
	allotFen(data){
		return request({
			url: baseUrl + '/device/StrategyFen',
			method:'POST',
			data
		})
	},
	/**
	 * 策略开关闸
	**/
	strategyControl(id,data){
		return request({
			url: baseUrl + '/device/StrategyControl/'+id,
			method:'POST',
			data
		})
	}
}